module.exports = __webpack_public_path__ + "static/bg-bc46737e6192679a0ca5a0179fa200db.mp4";